import styled from 'styled-components';

export const AttributeFacility = styled.div`
  width: 100%;
  height: 19px;
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: normal;
`;
